module.exports = __webpack_public_path__ + "static/media/item_2_7.3a78a8f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/item_2_7.png
// module id = 114
// module chunks = 0